const LOCALES = {
  tr: {
    translation: {
      hello: "Merhaba",
    },
  },
};

export default LOCALES;
